import { createListFilters, IOption } from '../../../../../components'

export type FaturasProfissionalFilters = {
  empresa?: IOption<number>
  mes?: IOption<string>
  ano?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<FaturasProfissionalFilters>({
    empresa: undefined,
    mes: undefined,
    ano: undefined,
  })
